<template>
  <div class="animated fadeIn">

    <b-card no-body>
      <b-card-body fluid="xl">
        <b-card-title class="text-center mb-2">
          <h2>Please click Start Speaking and then Say the word OR enter work in textbox</h2>
          <h2>कृपया बोलना शुरू करें पर क्लिक करें और फिर शब्द बोलें या टेक्स्ट बॉक्स में शब्द दर्ज करें</h2>
          <br />
          <b-button variant="primary" @click="startListening" v-if="!listening">
            <h3>Start Speaking (बोलना शुरू करें)</h3>
          </b-button>
          <b-button variant="danger" @click="stopListening" v-if="listening">
            <h3>Stop Speaking (बोलना बंद करें)</h3>
          </b-button>
          <b-button variant="danger" @click="speakMeaning" v-if="meaning != null">
            <h3>Speak Meaning</h3>
          </b-button>
        </b-card-title>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-body fluid="xl">
        <b-card-title class="text-center mb-2">
          <b-form-group label="Start entering word (शब्द दर्ज करना प्रारंभ करें)" label-for="word">
             <b-form-input id="word" name="word" @blur="blurMethod" @focus="wordFocused" maxlength="12"
              v-model="sourceText" />

            <b-list-group v-if="showListGroup" id="wordSearchList">
              <b-list-group-item ref="listIndexes" @keydown="keydownMethod(index)" @keyup="keyupMethod(index)"
                @click="searchListClicked(item[0])" v-for="(item, index) in transliteratedResults" button
                v-bind:key="index">{{ item[0] }}</b-list-group-item>
            </b-list-group>


          </b-form-group>
          <b-button class="text-center mb-2" variant="primary" @click="submitWordManual" :disabled="sourceText == null || sourceText.trim().length == 0">
            <h3>Submit Word (शब्द सबमिट करें)</h3>
          </b-button>

        </b-card-title>

      </b-card-body>

    </b-card>

    <b-card no-body>
      <b-card-body fluid="xl">
        <b-card-title class="text-center mb-2">
          <h2>Word</h2>
          <h1 v-if="recognizedText">{{ recognizedText }}</h1>
        </b-card-title>
        <b-row>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-body fluid="xl">
        <b-card-title class="text-center mb-2">
          <h2>Meaning</h2>
          <h1 v-if="meaning">{{ meaning }}</h1>
        </b-card-title>
      </b-card-body>
    </b-card>








  </div>
</template>

<script>
import annyang from 'annyang';
import Vue from 'vue'
import GoogleInputTool from 'google-input-tool';



export default {
  name: 'Dictionary',
  watch: {

    'sourceText': function (value) {
      let params = { "word": value };
      if (value != null && value.length >= 1 && this.selectedSearchOption == false) {
        this.transliterateText()
      }
      else if (this.sourceText == null || this.sourceText.length == 0){
        this.transliteratedResults = []
      }
    },
  },
  computed: {
    showListGroup: function () {
      var strWord = '' + this.word;
      return (this.transliteratedResults.length > 0 && this.selectedSearchOption === false && strWord.length >= 1)
    },
  },
  data() {
    return {
      recognizedText: '',
      listening: false,
      meaning: null,
      submitted: false,
      recognition: null,
      sourceText: '',
      transliteratedResults: [],
      selectedSearchOption: false,
      selectedWord: "",
      isSpeaking: false


    };
  },
  methods: {
    blurMethod(){
      if(this.showListGroup == true && event.relatedTarget.parentNode != null && event.relatedTarget.parentNode.id !='wordSearchList' ){
       this.selectedSearchOption = true;
      }
    },
    wordFocused(){
        this.selectedSearchOption = false;
    },
    keyupMethod(index){
      if(event.keyCode == 27){
        this.selectedSearchOption = true;
      }
    },
    searchListClicked(item){
    
      this.selectedWord = item;
     this.sourceText = item;
     this.recognizedText = item;
     this.selectedSearchOption = true;
      this.transliteratedResults = [];
      

    },
    keydownMethod(index){
      if(index == (this.transliteratedResults.length - 1) && event.keyCode == 9 && event.shiftKey == false){
        event.preventDefault();
        this.$refs.listIndexes[index].focus();
        return false;

      }
      else if (index == 0 && event.keyCode == 9 && event.shiftKey == true ){
        this.transliteratedResults = [];
      }
    },
      transliterateText() {
        const request = new XMLHttpRequest();
        const sourceText = this.sourceText;
        const inputLanguageCode = 'ne-t-i0-und'; // Example language code for Nepal
        const maxResult = 5; // Max number of transliterated results
  
        // Create a new instance of GoogleInputTool with the specified parameters
        GoogleInputTool(request, sourceText, inputLanguageCode, maxResult)
        .then(googleInputTool => {
          // Assuming the googleInputTool instance has a method to get transliterations
         this.transliteratedResults = googleInputTool
        })
        .catch(error => {
          this.showErrorMsg({message: error})         
        });
      },
    startListening() {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
      if (typeof SpeechRecognition === "undefined") {
        console.log('Your browser does not support Speech Recognition. Sorry.');
        this.showErrorMsg({
          message: 'Your browser does not support Speech Recognition. Sorry.'
        });
      }
      else {

        this.recognition = new SpeechRecognition();
        console.log(this.recognition);
        this.recognition.lang = 'hi-IN';
        const start = () => { this.recognition.start(); };
        const stop = () => { this.recognition.stop(); };
        const onResult = event => {
          console.log(event);
          const result = event.results[event.results.length - 1];
          this.recognizedText = result[0].transcript;
          console.log(result[0].transcript);
          console.log(result.isFinal);
          if (result.isFinal == true) {


            this.submitWord();
          }

        };
        this.recognition.continuous = true;
        this.recognition.interimResults = false;
        this.recognition.addEventListener("result", onResult);
        start();
        this.listening = true;
      }

    },
    speakMeaning() {
      try {
        if (this.isSpeaking) {
        speechSynthesis.cancel();
        this.isSpeaking = false;
      }
        if ('speechSynthesis' in window) {
          console.log('start speaking')
          const synth = speechSynthesis;

          const utterance = new SpeechSynthesisUtterance(this.meaning);
          // utterance.text = this.meaning;  
          utterance.addEventListener('start', event => { console.log('start event') });
          utterance.addEventListener('end', event => { console.log('end event') 
          this.isSpeaking = false;

          });
          utterance.addEventListener('error', event => {  this.isSpeaking = false;
            console.error('SpeechSynthesisUtterance.onerror', event);
          
          });
          utterance.lang = 'hi-IN';
          utterance.pitch = 1;
          utterance.rate = 1;
          utterance.volume = 1;

          synth.speak(utterance);
        } else {
          console.log('Text-to-speech not supported.');
          this.showErrorMsg({
            message: 'Text-to-speech not supported.'
          });
        }

      }
      catch (error) {
        console.log(error);
        this.showErrorMsg({
          message: error
        });
      }
    },
    stopListening() {
      console.log('stopping listing');
      this.recognition.stop();
      this.listening = false; // Set listening flag to false
    },
    submitWordManual(){
      if(this.sourceText != null && this.sourceText.length > 0){
        this.recognizedText = this.sourceText;
      }
      this.submitWord();
    },
    submitWord() {
      if(this.listening == true){
        this.stopListening();

      }
      this.meaning = null;
      console.log('submiting page: ' + this.listening);
      if (this.submitted == false && this.listening == false) {
        let params = { word: this.recognizedText };
        this.submitted = true;
        Vue.axios.post("/searchmeaning", params)
          .then(response => {

            if (typeof response.data !== "undefined" && response.data.success == true) {
              this.meaning = response.data.wordmeaning.meaning1;
              this.showSuccessMsg();
              this.submitted = false;
              this.speakMeaning();
            }
            else if (typeof response.data !== "undefined" && response.data.success == false) {
              this.showErrorMsg({
                message: response.data.error
              });
              this.submitted = false;
            }



          })
          .catch(error => {
            this.submitted = false;
            console.log(error);
            if (error.response.status == 400 || error.response.status == 422) {
              this.showErrorMsg({
                message: error.response.data.error
              });
            } else {
              this.showErrorMsg();
            }
          })
          




      }
    }
  },
  create() {

  },
  beforeDestroy() {
    speechSynthesis.cancel();
  },
};
</script>